module.exports = __webpack_public_path__ + "static/media/cs-cover.18e321d7.jpg";